<template>
    <v-container>
        <loading v-model="loading" />

        <cpPageTitle title="sezione admin" centered>
            <template v-slot:actions>
                <router-link :to="`/admin/marketing`" class="text-decoration-none">
                    <v-btn color="primary" :icon="!$vuetify.breakpoint.mdAndUp" :rounded="$vuetify.breakpoint.mdAndUp">
                        <v-icon :class="{ 'pr-2': $vuetify.breakpoint.mdAndUp }">groups</v-icon>
                        <span class="d-none d-md-inline">marketing</span>
                    </v-btn>
                </router-link>

                <router-link :to="`/admin/repprovince`" class="text-decoration-none">
                    <v-btn color="primary" :icon="!$vuetify.breakpoint.mdAndUp" :rounded="$vuetify.breakpoint.mdAndUp">
                        <v-icon :class="{ 'pr-2': $vuetify.breakpoint.mdAndUp }">download</v-icon>
                        <span class="d-none d-md-inline">report provincia</span>
                    </v-btn>
                </router-link>

                <router-link :to="`/admin/cleardb`" class="text-decoration-none">
                    <v-btn color="success" :icon="!$vuetify.breakpoint.mdAndUp" :rounded="$vuetify.breakpoint.mdAndUp">
                        <v-icon :class="{ 'pr-2': $vuetify.breakpoint.mdAndUp }">refresh</v-icon>
                        <span class="d-none d-md-inline">pulisci db</span>
                    </v-btn>
                </router-link>

                <router-link :to="`/admin/actionlog`" class="text-decoration-none">
                    <v-btn color="success" :icon="!$vuetify.breakpoint.mdAndUp" :rounded="$vuetify.breakpoint.mdAndUp">
                        <v-icon :class="{ 'pr-2': $vuetify.breakpoint.mdAndUp }">list</v-icon>
                        <span class="d-none d-md-inline">sezione log</span>
                    </v-btn>
                </router-link>

                <router-link :to="`/admin/updateCoordinates`" class="text-decoration-none">
                    <v-btn color="success" :icon="!$vuetify.breakpoint.mdAndUp" :rounded="$vuetify.breakpoint.mdAndUp">
                        <v-icon :class="{ 'pr-2': $vuetify.breakpoint.mdAndUp }">my_location</v-icon>
                        <span class="d-none d-md-inline">aggiornamento coordinate</span>
                    </v-btn>
                </router-link>
            </template>
        </cpPageTitle>

        <v-row class="text-center">
            <v-col cols="12" class="mt-6">
                <v-row :class="{ '': !$vuetify.breakpoint.mdAndUp, 'mt-3': $vuetify.breakpoint.mdAndUp }">
                    <template v-for="s of this.stats">
                        <v-col :cols="12" :sm="6" :key="s.text">
                            <v-card class="mx-auto" max-width="400" :color="s.color" elevation="12">
                                <v-list-item two-line>
                                    <v-list-item-content>
                                        <v-list-item-title class="text-h5">
                                            <v-icon large center class="ma-3 white--text"> {{ s.icon }} </v-icon>
                                        </v-list-item-title>
                                        <v-list-item-subtitle class="text-h5 text-uppercase white--text">{{ s.text }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>

                                <v-card-text class="text-center white--text">
                                    <div class="text-h2">{{ s.value }}</div>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </template>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import loading from '@/components/loading.vue'
import cpPageTitle from '@/components/cpPageTitle.vue'

export default {
    name: 'Admin',
    components: { loading, cpPageTitle },
    data() {
        return {
            loading: false,
            stats: {
                leads: { text: 'lead', value: null, color: 'primary', icon: 'store' },
                leadstocheck: { text: 'lead da controllare', page: 'lead', value: null, color: 'primary', icon: 'warning' },
                agents: { text: 'agente', value: null, color: 'primary', icon: 'groups' },
                zones: { text: 'zona', value: null, color: 'primary', icon: 'pin_drop' }
            }
        }
    },
    watch: {},
    async created() {
        this.loading = true
        if (!this.$permission(this.$auth.utente.role.name, 'AdminPage')) {
            this.$router.push('/')
        }
        //get number of leads
        let filters = {}
        filters[`filters[$and][0][disabled][$eq]`] = false
        const leads = await this.$http.get('leads', {
            'pagination[pageSize]': 1,
            'pagination[page]': 1,
            ...filters
        })
        this.stats.leads.value = leads.meta.pagination.total || 0
        //get number of leadstocheck
        filters = {}
        filters[`filters[$and][0][disabled][$eq]`] = false
        const leadstocheck = await this.$http.get('leadToChecks', {
            'pagination[pageSize]': 1,
            'pagination[page]': 1,
            ...filters
        })
        this.stats.leadstocheck.value = leadstocheck.meta.pagination.total || 0
        //get number og agents
        filters = {}
        filters[`filters[$and][0][user][role][name][$ne]`] = 'Super'
        filters[`filters[$and][1][user][role][name][$ne]`] = 'Ufficio'
        const agents = await this.$http.get('agents', {
            'pagination[pageSize]': 1,
            'pagination[page]': 1,
            ...filters,
            'populate': ['user', 'user.role']
        })
        this.stats.agents.value = agents.meta.pagination.total || 0
        //get number of zones
        filters = {}
        const zones = await this.$http.get('zones', {
            'pagination[pageSize]': 1,
            'pagination[page]': 1,
            ...filters
        })
        this.stats.zones.value = zones.meta.pagination.total || 0
        this.loading = false
    },
    methods: {}
}
</script>
<style>
/* Stile CSS personalizzato */
</style>
